import React, {useState} from 'react';
import s from './PaymentByTemplate.module.css'
import {useNavigate, useParams} from "react-router-dom";
import VerifyWithdrawalHelper from "../../../../helpers/VerifyWithdrawalHelper";
import PaymentByBankTransactionTemplate
    from "../../../../components/TransactionTemplates/PaymentByBankTransactionTemplate/PaymentByBankTransactionTemplate";
import PaymentByInternalTransactionTemplate
    from "../../../../components/TransactionTemplates/PaymentByInternalTransactionTemplate/PaymentByInternalTransactionTemplate";
import CustomModal from "../../../../components/ui/CustomModal/CustomModal";
import styles from "../../../../styles/styles.module.css";
import MyBtn from "../../../../components/ui/MyBtn/MyBtn";
import {useAppSelector} from "../../../../hooks/redux";

const PaymentByTemplate = () => {

    const [purpose, setPurpose] = useState('External transfer')
    const {id, type} = useParams()

    const [isButtonDisable, setIsButtonDisabled] = useState(true)
    const [withdrawalStatus, setWithdrawalStatus] = useState("")


    if ((withdrawalStatus === 'notVerified' || withdrawalStatus === 'blocked' || withdrawalStatus === '') && (id !== "create")) {
        return (
            <VerifyWithdrawalHelper
                setWithdrawalStatus={setWithdrawalStatus}
                setIsButtonDisabled={setIsButtonDisabled}
            />
        )
    }



    return (
        <div className={s.templateWrapper}>

            <div className={s.payer_details}>
                <p className={s.title}>Payer Details</p>
                {
                    purpose === "External transfer"
                        ? <PaymentByBankTransactionTemplate
                            id={id}
                            setPurpose={setPurpose}
                            isButtonDisable={isButtonDisable}
                        />
                        : <PaymentByInternalTransactionTemplate
                            id={id}
                            templateName={''}
                            setPurpose={setPurpose}
                            isButtonDisable={isButtonDisable}
                            withdrawalStatus={withdrawalStatus}
                        />
                }
            </div>

        </div>

    )
}

export default PaymentByTemplate;
